import type { FC } from "react";

import type { PropsWithClassName } from "@/components/podkit/lib/cn";

export const IconCircleX: FC<PropsWithClassName> = ({ className }) => {
    return (
        <svg
            className={className}
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.83331 8C1.83331 4.3181 4.81808 1.33333 8.49998 1.33333C12.1819 1.33333 15.1666 4.3181 15.1666 8C15.1666 11.6819 12.1819 14.6667 8.49998 14.6667C4.81808 14.6667 1.83331 11.6819 1.83331 8ZM6.49998 5.52859L6.02858 6L8.02858 8L6.02858 10L6.49998 10.4714L8.49998 8.4714L10.5 10.4714L10.9714 10L8.97138 8L10.9714 6L10.5 5.52859L8.49998 7.52859L6.49998 5.52859Z"
                fill="currentColor"
            />
        </svg>
    );
};
